export const Organization = (props: any) => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="#3D79F2" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22.3824 19.8452V15.6099H13.2059V12.7471C14.2339 12.6329 15.1887 12.2724 16.0097 11.7262C15.9314 10.9438 15.5936 10.1828 14.9957 9.58482C13.6195 8.20873 11.3804 8.20868 10.0043 9.58482C9.40635 10.1828 9.06852 10.9438 8.99026 11.7262C9.81134 12.2724 10.7661 12.6329 11.7941 12.7471V15.6099H2.61765V19.8452H0.5V24.0805H6.14706V19.8452H4.02941V17.0217H11.7941V19.8452H9.67647V24.0805H15.3235V19.8452H13.2059V17.0217H20.9706V19.8452H18.8529V24.0805H24.5V19.8452H22.3824Z"
      fill="#5C5C5C"
      {...props}
    />
    <path
      d="M10.3961 7.60869C8.77704 5.82789 10.0684 2.89495 12.499 2.9036C14.9295 2.8949 16.221 5.82826 14.602 7.60864C15.8442 8.19151 16.8241 9.29043 17.2324 10.6653C20.8724 6.65772 17.9671 0.0604985 12.4989 0.080122C7.03102 0.0604514 4.12528 6.65881 7.76551 10.6654C8.17455 9.28831 9.15586 8.19052 10.3961 7.60869Z"
      fill="#5C5C5C"
      {...props}
    />
    <path
      d="M11.0859 5.72622C11.0859 6.50467 11.7193 7.13798 12.4977 7.13798C14.3706 7.06043 14.37 4.39172 12.4977 4.31445C11.7193 4.31445 11.0859 4.94777 11.0859 5.72622Z"
      fill="#5C5C5C"
      {...props}
    />
  </svg>
);
